import { getRestrictionStatusId as getRestrictionStatusIdByType } from 'features/profile-restrictions/constants';
import { Endpoints } from 'UI/constants/endpoints';
import { ENTITY_TYPE_ID_MAP } from 'UI/constants/entityTypes';

const SUB_STATUS_QUERY = 'orderBy=title&direction=asc';

const SUB_STATUS_ENDPOINT_BY_ENTITY = {
  [ENTITY_TYPE_ID_MAP.candidate]: Endpoints.CandidateSubStatuses,
  [ENTITY_TYPE_ID_MAP.hiringAuthority]: Endpoints.HiringAuthoritySubStatuses,
  [ENTITY_TYPE_ID_MAP.name]: Endpoints.NameSubStatuses
};

export const getRestrictionStatusId = ({ entityTypeId, selectedRestrictionType }) =>
  getRestrictionStatusIdByType({ entityTypeId, restrictionType: selectedRestrictionType });

export const getRestrictionSubStatusEndpoint = ({ entityTypeId, selectedRestrictionType }) => {
  const baseEndpoint = SUB_STATUS_ENDPOINT_BY_ENTITY[entityTypeId];
  const statusId = getRestrictionStatusId({ entityTypeId, selectedRestrictionType });

  if (!baseEndpoint || !statusId) return null;

  return `${baseEndpoint}?${SUB_STATUS_QUERY}&statusId=${statusId}`;
};
